var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isValidPermission(_vm.apiCode) ? _c('b-button', _vm._g({
    class: {
      'd-none': !_vm.isValidPermission(_vm.apiCode)
    },
    style: _vm.style,
    attrs: {
      "variant": _vm.variant,
      "disabled": _vm.disabled
    }
  }, _vm.$listeners), [_vm._t("default")], 2) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }